import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=76b177d0&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b177d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76b177d0')) {
      api.createRecord('76b177d0', component.options)
    } else {
      api.reload('76b177d0', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=76b177d0&scoped=true", function () {
      api.rerender('76b177d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/vocational-evaluation/tabs/three-to-four/Main.vue"
export default component.exports